var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('VuePNotify',{attrs:{"options":_vm.options}}),(_vm.loader)?_c('div',{staticClass:"is-loader w-100 h-100"},[_vm._m(0)]):_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content d-flex justify-content-center align-items-center"},[_c('img',{attrs:{"src":require("./assets/global_assets/images/logo_dark.png"),"alt":"Loading.."}})])
}]

export { render, staticRenderFns }